<app-nav-menu #navMenu [userName]='userName' [email]='email' [currentCustomer]='currentCustomer' (changedCustomerEmitter)='receiveCustomer($event)'></app-nav-menu>
<router-outlet *ngIf="!loading" (activate)="onActivate($event)" id="appIdTarget"></router-outlet>
<app-footer #footer [lastLogonDate]='lastLogonDate'></app-footer>
<app-customer-selector  #customerSelector [customers]='customers' (currentCustomer)="receiveCustomer($event)"
                       *ngIf="customers?.length > 1 && isOnLogin"></app-customer-selector>

<div style="visibility:hidden">
    <ejs-dialog #sessionTimeoutModal id="sessionTimeoutModal" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='true'
                [showCloseIcon]='false' [width]='modalWidth' [position]='position' [visible]='hidden' [height]='modalHeight'
                (overlayClick)="onOverlayClick()" [buttons]='dlgButtons'>

        <div class="card">
            <div class="card-header bg-primary">
                <h3 class="card-title text-white" tabindex="0" role="heading" aria-label="session expiring" aria-level="3"> Session Expiring</h3>
            </div>
            <div class="card-body">
                <p tabindex="0" role="paragraph">
                    Your session will expire in <b>{{ sessionExpireSecondsLeft + 1 | number : '1.0-0' }}</b> seconds.
                </p>
            </div>
        </div>
    </ejs-dialog>
</div>

<div class="col-sm-11 center-block" *ngIf="loading">
  <div class="row">
      <div id="loading"></div>
  </div>
</div>
